import os from './operating-system.js'

const LINKS = {
  android: {
    carpool: 'market://details?id=com.ridewith',
    waze: 'market://details?id=com.waze'
  },
  ios: {
    carpool: 'https://itunes.apple.com/us/app/waze-carpool/id1091029104',
    waze: 'https://itunes.apple.com/us/app/waze-navigation-live-traffic/id323229106'
  }
}

const download = () => {
  // cache download and vendor buttons
  const downloaders = Array.prototype.slice.call(document.querySelectorAll('[data-download]'))
  const vendors = Array.prototype.slice.call(document.querySelectorAll('.vendor'))

  // if no mobile operating system
  if (!os) {
    // hide downloaders
    downloaders.forEach(button => {
      // ignore downloaders with hrefs, because these drive to download pages when not on
      // a mobile OS
      if (!button.hasAttribute('href')) {
        button.classList.add('is-hidden')
      }
    })

    // exit early
    return
  }

  // cache OS results
  const isIOS = os === 'ios'
  const isAndroid = os === 'android'

  // hide vendors
  vendors.forEach(button => button.classList.add('is-hidden'))

  // set hrefs
  downloaders.forEach(button => {
    // cache download attribute value
    const app = button.getAttribute('data-download')

    // proceed based on app
    if (app === 'waze') {
      if (isIOS) button.setAttribute('href', LINKS.ios.waze)
      if (isAndroid) button.setAttribute('href', LINKS.android.waze)
    }

    if (app === 'carpool') {
      if (isIOS) button.setAttribute('href', LINKS.ios.carpool)
      if (isAndroid) button.setAttribute('href', LINKS.android.carpool)
    }
  })
}

export default download
